// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header_32fJW"};